'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getClassName;

var _hash = require('@emotion/hash');

var _hash2 = _interopRequireDefault(_hash);

var _getSafeValue = require('./get-safe-value');

var _getSafeValue2 = _interopRequireDefault(_getSafeValue);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Generates the class name.
 */


function getClassName(propertyInfo, value) {
  var className = propertyInfo.className,
      _propertyInfo$safeVal = propertyInfo.safeValue,
      safeValue = _propertyInfo$safeVal === undefined ? false : _propertyInfo$safeVal,
      _propertyInfo$complex = propertyInfo.complexValue,
      complexValue = _propertyInfo$complex === undefined ? false : _propertyInfo$complex;
  var valueKey = void 0; // Shortcut the global keywords

  if (value === 'inherit' || value === 'initial' || value === 'unset') {
    valueKey = value; // Always hash values that contain a calc() because the operators get
    // stripped which can result in class name collisions
  } else if (complexValue || value.includes('calc(')) {
    valueKey = (0, _hash2.default)(value);
  } else if (safeValue) {
    valueKey = value;
  } else {
    valueKey = (0, _getSafeValue2.default)(value);
  }

  return "\uD83D\uDCE6" + className + '_' + valueKey;
}